import { QUESTION_TYPES, QUESTION_TYPE_CODE } from "../../../constants/comman";
import { getContentSubTypeCode } from "../../../utils";

const defaultOption = {
  correctAnswer: { answerType: 'id', data: [] },
  optionsContent: [
    { id: 'A', value: '', serialNo: 1 },
    { id: 'B', value: '', serialNo: 2 },
    { id: 'C', value: '', serialNo: 3 },
    { id: 'D', value: '', serialNo: 4 }
  ]
};

const getDefaultFormData = (subType?: string) => {
  // TODO form data interface later and also push this function in utils   
  const contentFromData: any = {
    tags: [],
    difficultyLevel: [],
    difficultyType: [],
    relevantExams: [],
    question: "",
    subjects: [],
    conceptId: [],
    conceptCode: [],
    name: "",
    description: "",
    courseId: [],
    settings: {
      shuffle: {
        answer: false,
        questions: false,
        sections: false
      },
      pause: false,
      language: [],
      noOfAttempts: 0,
      testType: "",
      variation: false
    },
    completionPercent: 0,
    authors: [],
    secondarySubjects: [],
    mandatoryFields:  {
      hints: true
    },
    syllabusExams: [],
  };

  switch (getContentSubTypeCode(subType)) {
    case "0":
      contentFromData['content'] = [
        {
          correctAnswer: { answerType: "id", data: [] },
          optionsContent: [
            { id: "A", value: "", serialNo: 1 },
            { id: "B", value: "", serialNo: 2 },
            { id: "C", value: "", serialNo: 3 },
            { id: "D", value: "", serialNo: 4 }
          ]
        }
      ]
      break;
    case "1":
      contentFromData['content'] = [
        {
          matrixOptionContent: {
            optionLeft: [
              { id: "Left1", value: "", serialNo: 1 },
              { id: "Left2", value: "", serialNo: 2 },
              { id: "Left3", value: "", serialNo: 3 },
              { id: "Left4", value: "", serialNo: 4 },
            ],
            optionRight: [
              { id: "Right1", value: "", serialNo: 1 },
              { id: "Right2", value: "", serialNo: 2 },
              { id: "Right3", value: "", serialNo: 3 },
              { id: "Right4", value: "", serialNo: 4 },
            ]
          },
          correctAnswer: { answerType: "id", data: [] },
        }
      ]
      break;
    case "2":
      // true & false 
      contentFromData['content'] = [
        {
          correctAnswer: { answerType: "id", data: [] },
          optionsContent: [
            { id: "A", value: "True", serialNo: 1 },
            { id: "B", value: "False", serialNo: 2 }
          ]
        }
      ]
      break;
    case "5":
      contentFromData['content'] = [
        {
          correctAnswer: { answerType: "id", data: [] },
          optionsContent: [
            { id: "A", value: "", serialNo: 1 },
            { id: "B", value: "", serialNo: 2 },
            { id: "C", value: "", serialNo: 3 },
            { id: "D", value: "", serialNo: 4 }
          ]
        }
      ]
      break;
    case "8":
      contentFromData['content'] = [
        {
          correctAnswer: { answerType: "id", data: [] },
          optionsContent: [
            { id: "A", value: "", serialNo: 1 },
            { id: "B", value: "", serialNo: 2 },
            { id: "C", value: "", serialNo: 3 },
            { id: "D", value: "", serialNo: 4 }
          ]
        }
      ]
      break;
    default:
      contentFromData['content'] = []
  }
  // for option settings
  switch(getContentSubTypeCode(subType)) {
    case QUESTION_TYPES.SMCQ.toString():
    case QUESTION_TYPES.MMCQ.toString():
    case QUESTION_TYPES.MATRIX.toString():
      contentFromData.settings.option = {
        displayCount: 4,
        shuffleType: "same"
      }
      break;
    case QUESTION_TYPES.PARAGRAPH.toString():
      contentFromData.content[0] = {
        ...contentFromData.content[0],
        settings: {
          option: {
            displayCount: 4,
            shuffleType: "same"
          }
        }
      }
      break;
    
  }
  return contentFromData;
}

export function contentForPassageTypeQuestion(numberOfQuestion: number) {
  return Array.from({ length: numberOfQuestion }).map(() => ({ ...defaultOption }));
}

export default getDefaultFormData;